// What keeps clients happy across every campaign: texts only between 9am and
// 8pm, no more than one text in any three days, emails no more than every
// other day. Checked as the salon builds; the server will enforce the same
// rules across campaigns, journeys and Communications (docs/CAMPAIGNS_BACKEND.md).
import moment from 'moment'

export const TEXT_FROM = 9
export const TEXT_UNTIL = 20
const DAY = 24 * 60 * 60 * 1000

const when = (d) => moment(d).calendar(null, { sameDay: '[today]', nextDay: '[tomorrow]', nextWeek: 'dddd', sameElse: 'ddd D MMM' })

// True when a text at this time is inside the hours texts go out
export const textHoursOk = (at) => {
  const m = moment(at)
  const mins = m.hours() * 60 + m.minutes()
  return mins >= TEXT_FROM * 60 && mins <= TEXT_UNTIL * 60
}

// { [itemId]: { block?: string, warn?: string } } for the items switched on.
// `others`: what else is going out, [{ channel: 'sms'|'email', at, name }].
export const checkItems = (items = [], others = []) => {
  const out = {}
  const on = items.filter(i => i.on)
  const all = [
    ...on.map(i => ({ id: i.id, channel: i.channel, at: new Date(i.at), name: 'this campaign' })),
    ...others.filter(o => o && o.at).map(o => ({ ...o, at: new Date(o.at) })),
  ]
  on.forEach((i) => {
    const t = new Date(i.at)
    if (i.channel === 'sms') {
      if (!textHoursOk(t)) { out[i.id] = { block: 'Texts go out between 9am and 8pm. Pick a time in those hours.' }; return }
      const near = all.find(o => o.channel === 'sms' && o.id !== i.id && Math.abs(o.at - t) < 3 * DAY)
      if (near) out[i.id] = { warn: `Another text goes to clients ${when(near.at)}${near.name && near.name !== 'this campaign' ? ` (${near.name})` : ''}. Two texts within three days is more than most people want.` }
    } else if (i.channel === 'email') {
      const near = all.find(o => o.channel === 'email' && o.id !== i.id && Math.abs(o.at - t) < 1.5 * DAY)
      if (near) out[i.id] = { warn: `Another email goes out ${when(near.at)}${near.name && near.name !== 'this campaign' ? ` (${near.name})` : ''}. Leave a day between them if you can.` }
    }
  })
  return out
}
